// Google Ads conversion tracking.
//
// The base Google tag (gtag.js) is injected in index.html (Google Ads account
// AW-18425858763). These fns fire conversion events from the app funnel so the
// Search campaign's Smart Bidding can optimize toward real signups instead of
// raw clicks:
//   - trackAdsConversion('signup') → free account created (SignUpPage)
//
// window.gtag is added by the base tag snippet. Calls are guarded so they
// silently no-op if the tag failed to load or an ad blocker stripped it —
// callers never null-check, and analytics can never break the app. Same shape
// as src/lib/metaPixel.ts.
//
// NOTE: fired for EMAIL signups only (same place as the Meta Pixel
// CompleteRegistration). Google-OAuth signups are indistinguishable from
// returning logins client-side without touching useAuth, so they're
// intentionally not counted — an undercount is safer for Smart Bidding than
// counting returning users as fresh conversions.

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

// Google Ads conversion actions — value is the event snippet's `send_to`
// ("<AW-tag>/<conversion-label>"). Add new actions here as they're created in
// Google Ads (e.g. a 'purchase' label once a Subscribe conversion exists).
const CONVERSIONS = {
  signup: 'AW-18425858763/HXiQCNTGm-8cEMuVkdJE',
} as const;

/** Fire a Google Ads conversion. Safe to call anywhere — no-ops when the tag
 *  isn't available (ad blockers, load failure). */
export function trackAdsConversion(name: keyof typeof CONVERSIONS): void {
  try {
    if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
    window.gtag('event', 'conversion', { send_to: CONVERSIONS[name] });
  } catch {
    // Analytics must never throw into the app.
  }
}
